import Axios from 'axios';
import localStorageAdapter from '@/utils/LocalStorageAdapter';
var host = window.location.host;
var domains = host.split('.');
var topLevel = domains.pop();
var primaryDomain = domains.pop();
var origin = primaryDomain + "." + topLevel;
var base, baseUrlOrigin, appName;
baseUrlOrigin = origin;
// overwrite for localhost
// TODO use environment vars
if (origin.indexOf('localhost') !== -1 || host.indexOf('dev') === 0) {
    baseUrlOrigin = 'tp-devel.com'; //`${process.env.APP_HOST}`;
}
// @ts-ignore
var masterConfig = window.__app_details || __app_details || {};
// __app_details is attached to the window upon initial load
// it is later used by Vue as $appConstants
if (masterConfig.locationBase) {
    base = masterConfig.locationBase;
    appName = masterConfig.appName;
}
var endpointBaseUrl = masterConfig.endpointBaseUrl || location.protocol + "//c1." + baseUrlOrigin;
var axios = Axios.create({
    baseURL: endpointBaseUrl,
    timeout: 30000,
});
axios.defaults.headers.common['Content-Type'] = 'application/html; charset=utf-8';
axios.defaults.withCredentials = true;
// TODO make configurable.
export var baseURL = endpointBaseUrl;
export var service = axios;
export var squibTestEndpoint = 'squib_load_olo';
export { base };
export { appName };
export { localStorageAdapter };



//////////////////
// WEBPACK FOOTER
// ./src/services/app.service.ts
// module id = 344R
// module chunks = 18